import React from 'react';
import eventData from '../../data/event/events.json';
import speakerData from '../../data/instructor/instructor.json';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Timer from 'react-compound-timer';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import PopularCourse from './../courses/components/PopularCourse';
import CourseTag from './../courses/components/CourseTag';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/eventDetails.js';

function EventDetails() {
    const { id } = useParams();

    const events = eventData.dataList || eventData;
    const event = events.find((item) => String(item.id) === String(id));

    const speakers = speakerData.dataList || speakerData;

    if (!event) {
        return (
            <Styles>
                <div className="main-wrapper event-details-page">
                    <HeaderTwo />
                    <BreadcrumbBox title="Event Not Found" />
                    <div className="text-center py-5">
                        <h3>Event not found</h3>
                    </div>
                    <FooterTwo />
                </div>
            </Styles>
        );
    }

    // const currentIndex = events.findIndex((item) => String(item.id) === String(id));
    // const prevEvent = currentIndex > 0 ? events[currentIndex - 1] : null;
    // const nextEvent = currentIndex < events.length - 1 ? events[currentIndex + 1] : null;

    return (
        <Styles>
            <div className="main-wrapper event-details-page">
                <HeaderTwo />

                <BreadcrumbBox title={event.eventTitle} />

                <section className="event-details-area">
                    <Container>
                        <Row>
                            <Col lg="9" md="8" sm="12">
                                <div className="event-details-content">

                                    <div className="event-details-banner">
                                        <img
                                            src={`/assets/images/${event.eventImg}`}
                                            alt={event.eventTitle}
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="heading">
                                        <h4>{event.eventTitle}</h4>
                                    </div>

                                    <div className="event-icon">
                                        <ul className="list-unstyled list-inline">
                                            <li className="list-inline-item">
                                                <i className="las la-calendar"></i> {event.eventDate}
                                            </li>
                                            <li className="list-inline-item">
                                                <i className="las la-clock"></i> {event.eventTime}
                                            </li>
                                            <li className="list-inline-item">
                                                <i className="las la-map-marker"></i> {event.eventLocation}
                                            </li>
                                            <li className="list-inline-item">
                                                <i className="las la-copy"></i> University Event
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="event-details-overview">
                                        <h5>Event Overview</h5>
                                        <p>
                                            {event.eventdesc}
                                            <br /><br />
                                            This event is organized to provide students with valuable exposure,
                                            practical learning, and active participation in academic and
                                            co-curricular development activities. It offers a great opportunity
                                            to engage, learn, and grow in a vibrant educational environment.
                                            <span>
                                                <i className="las la-quote-right"></i>
                                                Join this event to explore new ideas, connect with others, and
                                                experience meaningful learning beyond the classroom.
                                            </span>
                                        </p>

                                        <ul className="list-unstyled">
                                            <li>
                                                <i className="fa fa-check"></i> Meaningful learning and participation opportunities
                                            </li>
                                            <li>
                                                <i className="fa fa-check"></i> Interaction with faculty, students, and special guests
                                            </li>
                                            <li>
                                                <i className="fa fa-check"></i> Academic, cultural, and professional exposure
                                            </li>
                                        </ul>
                                    </div>


                                    {/* <
                                    <div className="pre-nxt-event">
                                        <Row>
                                            <Col md="6">
                                                {prevEvent && (
                                                    <div className="next-prev-item prev-event d-flex">
                                                        <div className="prev-img">
                                                            <img
                                                                src={`/assets/images/${prevEvent.eventImg}`}
                                                                alt={prevEvent.eventTitle}
                                                            />
                                                        </div>
                                                        <div className="prev-text">
                                                            <p>
                                                                <Link to={`/event-details/${prevEvent.id}`}>
                                                                    {prevEvent.eventTitle}
                                                                </Link>
                                                            </p>
                                                            <span>{prevEvent.eventDate}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </Col>

                                            <Col md="6">
                                                {nextEvent && (
                                                    <div className="next-prev-item next-event d-flex flex-row-reverse text-right">
                                                        <div className="next-img">
                                                            <img
                                                                src={`/assets/images/${nextEvent.eventImg}`}
                                                                alt={nextEvent.eventTitle}
                                                            />
                                                        </div>
                                                        <div className="next-text">
                                                            <p>
                                                                <Link to={`/event-details/${nextEvent.id}`}>
                                                                    {nextEvent.eventTitle}
                                                                </Link>
                                                            </p>
                                                            <span>{nextEvent.eventDate}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                    </div> */}
                                </div>

                            </Col>

                            <Col lg="3" md="4" sm="12">
                                <div className="event-details-sidebar">
                                    <Row>
                                        <Col md="12">
                                            <div className="event-sidebar-info">
                                                <div className="event-sidebar-timer text-center">
                                                    <Timer initialTime={1040 * 970 * 980} direction="backward">
                                                        <p><Timer.Days /><span>Days</span></p>
                                                        <p><Timer.Hours /><span>Hours</span></p>
                                                        <p><Timer.Minutes /><span>Minutes</span></p>
                                                    </Timer>
                                                </div>

                                                <ul className="list-unstyled event-info-list">
                                                    <li>Start Date: <span>{event.eventDate}</span></li>
                                                    <li>Time: <span>{event.eventTime}</span></li>
                                                    <li>Place: <span>{event.eventLocation}</span></li>
                                                    <li>Organizer: <span>Care University</span></li>
                                                    <li>Phone: <span>+91 7599020021</span></li>
                                                    <li>Email: <span>info@erptechpro.in</span></li>
                                                    <li>Website: <span>www.careuniversity.edu</span></li>
                                                </ul>

                                                <button className="buy-btn">
                                                    <Link to="/contact" className="text-white">
                                                        Register Now
                                                    </Link>
                                                </button>

                                            </div>
                                        </Col>

                                        <Col md="12">
                                            <PopularCourse />
                                        </Col>

                                        <Col md="12">
                                            <CourseTag />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div className="event-details-speaker">
                            <h5 className='mt-5 text-center'>Event Speakers</h5>
                            <Row>
                                {speakers.slice(0, 4).map((data, i) => (
                                    <Col lg="3" md="6" sm="6" key={i}>
                                        <div className="event-speaker-item">
                                            <img
                                                src={`/assets/images/${data.personImage}`}
                                                alt={data.personName}
                                                className="img-fluid"
                                            />
                                            <div className="img-content text-center">
                                                <h6>{data.personName}</h6>
                                                <p>{data.personTitle}</p>
                                                <ul className="list-unstyled list-inline">
                                                    <li className="list-inline-item">
                                                        <a href="#" >
                                                            <i className="fab fa-facebook-f"></i>
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="#" >
                                                            <i className="fab fa-twitter"></i>
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="#">
                                                            <i className="fab fa-youtube"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
}

export default EventDetails;